import { Request, Response } from "express"

import getUser from "../services/auth.js"
import log from "../log.js"

export const routeAuthPost = async (req: Request, res: Response) => {
	log(`routeAuthPost`)

	const user = await getUser({
		email: req.body.userName,
		password: req.body.password,
		appID: req.body.appID,
	})

	if (user === null) {
		log(`Could not find user: ${req.body.userName} with password ${req.body.password}`)

		res.status(401).json({ message: "Invalid username or password" })
	} else {
		log(`Found user`)

		res.json(user)
	}
}
